/**
* @Description 文件功能说明：修改密码弹窗
* @Author cc
* @Time 2021/5/14
**/

/* HTML */
<template>
    <el-dialog :title="dialogForm.title"
               :visible.sync="dialogForm.dialogFormVisible"
               :close-on-click-modal="false"
               custom-class="form-dialog"
               v-dialogDrag
               class="dialog_title"
               @close="handleDialogClose"
    >

        <el-form :model="dialogRowForm" :rules="rules" ref="dialogRowForm" label-width="120px">
            <el-form-item label="车辆组名：" prop="groupName" style="margin-bottom: 20px;">
                <el-input v-model="dialogRowForm.groupName" clearable/>
            </el-form-item>
            <el-form-item class="btn-form-item-c">
                <el-button type="primary" @click="submitForm()"><i class="el-icon-success" /> {{dialogForm.submitButton}}</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>

</template>

/* JS */
<script>
    import ApiCar from '@/request/api-car'
    import {checkEmpty,validFormat,checkFormat} from '@/global/global-valid'

    export default {
        /**
         * @Des 组件名
         * @Auth CC
         * @Date 2021/5/14
         */
        name: 'UserGroupDialog',
        /**
         * @Des 数据定义
         * @Auth CC
         * @Date 2021/5/14
         */
        data() {
            return{
                /**
                 * @Des 弹窗表单
                 * @Auth CC
                 * @Date 2021/5/14
                 */
                dialogForm: {
                    isEdit: true,
                    title: "车辆组",
                    dialogFormVisible: false,
                    submitButton: '保存'
                },
                /**
                 * @Des 弹窗行值
                 * @Auth CC
                 * @Date 2021/5/14
                 */
                dialogRowForm: {
                    parentId: '',
                    groupId: '',
                    groupName: '',
                    submitLock: false
                },
                /**
                 * @Des 弹窗规则
                 * @Auth CC
                 * @Date 2021/5/14
                 */
                rules: {
                    groupName: [
                        { required: true, message: '请输入车辆组名', trigger: 'blur' },
                        {
                        	validator: (rule, value, callback) => {
	                            if (!checkFormat(value, validFormat.username_xm)) {
	                            	new callback(new Error("名称不合法。可包含：汉字、字母、数字、下划线等"));
	                            } else {
	                                callback()
	                            }
	                        },
	                        trigger: "blur"
                        }
                    ],
                },
            }
        },
        /**
	     * @Des 初始化页面加载完成后的处理
	     * @Auth CC
	     * @Date 2021/5/14
	     */
        created () {

        },
        /**
         * @Des 方法定义
         * @Auth CC
         * @Date 2021/5/14
         */
        methods:{
            /**
             * @Des 弹窗打开
             * @Auth CC
             * @Date 2021/5/14
             */
            openDialog(isEdit, data){
                // console.log(isEdit, data)
                this.dialogForm.isEdit = isEdit;
                if(isEdit){
                    this.dialogForm.title = '编辑车辆组';
                    this.dialogRowForm.parentId = data.parentId;
                    this.dialogRowForm.typeId = data.parentId;
                    this.dialogRowForm.groupId = data.id;
                    this.dialogRowForm.groupName = data.name;
                }else{
                    this.dialogForm.title = '添加车辆组';
                    this.dialogRowForm.parentId = data.parentId;
                    this.dialogRowForm.typeId = data.id;
                    this.dialogRowForm.typeName = data.name;
                    this.dialogRowForm.groupId = '';
                    this.dialogRowForm.groupName = '';
                }
                this.dialogForm.dialogFormVisible = true;
            },
            /**
             * @Des 弹窗关闭
             * @Auth CC
             * @Date 2021/5/14
             */
            handleDialogClose(){
                this.reset()
            },
            /**
             * @Des 重置方法
             * @Auth CC
             * @Date 2021/5/14
             */
            reset(){
                this.cleanData(this.dialogRowForm);
                this.cleanValidate('dialogRowForm');
            },
            /**
             * @Des 提交方法
             * @Auth CC
             * @Date 2021/5/14
             */
            submitForm(){
                if(this.dialogRowForm.submitLock){
                    return;
                }
                // 表单验证
                this.$refs.dialogRowForm.validate(valid => {
                    if(!valid) return false;
                    this.dialogRowForm.submitLock = true;
                    let api = this.dialogForm.isEdit?ApiCar.updateCarGroupApi: ApiCar.addCarGroupApi;
                    // 提交车辆组 交互
                    this.$request.postJsonRequest(api, {
                        groupId: this.dialogRowForm.groupId,
                        groupName: this.dialogRowForm.groupName,
                        // projectId: this.$store.state.currentProjectId
                    }).then(result => {
                        if(result.code == 0){
                            this.$message({
                                message: '车辆组保存成功！',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true,
                                onClose: (() => {})
                            });
                            // 刷新页面
                            this.dialogForm.dialogFormVisible = false;
                            this.$emit("flushGroup", this.dialogRowForm.groupId, this.dialogRowForm.groupName);
                            this.dialogRowForm.submitLock = false;
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            this.dialogRowForm.submitLock = false;
                        }
                    }).catch(error => {
                    	this.dialogRowForm.submitLock = false;
                        console.error('车辆组保存异常', api, error);
                    })
                })
            },
            /**
             * @Des 清除验证
             * @Auth CC
             * @Date 2021/5/14
             */
            cleanValidate(formName){
                // 清除表单校验的提示
                if (this.$refs[formName]) {
                    // 延时执行
                    this.$nextTick(function () {
                        this.$refs[formName].clearValidate();
                    })
                };
            },
            /**
             * @Des 清理数据
             * @Auth CC
             * @Date 2021/5/14
             */
            cleanData(form){
                this.$nextTick(function () {
                    // 重置数据
                    form = Object.assign({}, {
	                    groupId: '',
	                    groupName: '',
                    });
                });
            }

        }
    }
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_pages/Car/CarGroupDialog.vue